const { createContext } = require("react");

const ActiveModalContext = createContext();

export default ActiveModalContext;
